// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 查询优惠券 GET /coupons/plan/number/${param0} */
export async function couponsPlanNumberPlanNumberUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.couponsPlanNumberPlanNumberUsingGETParams,
  options?: { [key: string]: any },
) {
  const { planNumber: param0, ...queryParams } = params;
  return request<API.BaseResultCouponPlanResp>(`/coupons/plan/number/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}
